import MultiProjectDashboardView from '../views/MultiProjectDashboardView';

const DashboardRoutes = {
  path: 'dashboard',
  children: [
    {
      index: true,
      element: <MultiProjectDashboardView />,
    },
    {
      path: ':id',
      element: <MultiProjectDashboardView />,
    },
  ],
};

export default DashboardRoutes;
